/* eslint-disable consistent-return, default-case, no-param-reassign */
/*
 *
 * Help reducer
 *
 */

import produce from 'immer';

import { RESET_SWITCH_LOAN_STATE, RESET_USER_STATE } from '../Main/constants';
import {
  FETCH_FAQ,
  FETCH_FAQ_FAILURE,
  FETCH_FAQ_SUCCESS,
  RESET_STATE,
  SET_SELECTED_LETTER,
  SET_TARGET_TERM_ID,
  SET_VIDEO_MODAL_DATA,
  SET_VIDEO_REMAINING_DURATION,
  UPDATE_SELECTED_CATEGORY,
  UPDATE_SELECTED_QUESTION,
  UPDATE_STEP,
} from './constants';

export const initialState = {
  errors: {
    bannerError: false,
    serviceError: false,
  },
  faqCategories: [],
  faqSelectedCategory: null,
  faqSelectedQuestion: null,
  loading: true,
  selectedLetter: 'A',
  step: 1,
  successes: false,
  targetTermId: '',
  videoModalData: null,
  videoRemainingDuration: 0,
};

const helpReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case FETCH_FAQ: {
      draft.errors = initialState.errors;
      draft.loading = true;
      break;
    }
    case FETCH_FAQ_FAILURE: {
      const { error } = payload;
      draft.errors.serviceError = error;
      draft.loading = false;
      break;
    }
    case FETCH_FAQ_SUCCESS: {
      const { faqCategories } = payload;
      draft.faqCategories = faqCategories;
      draft.loading = false;
      break;
    }
    case RESET_STATE: {
      return initialState;
    }
    case RESET_SWITCH_LOAN_STATE: {
      return initialState;
    }
    case RESET_USER_STATE: {
      return initialState;
    }
    case SET_SELECTED_LETTER: {
      const { letter } = payload;
      draft.selectedLetter = letter;
      break;
    }
    case SET_TARGET_TERM_ID: {
      const { id } = payload;
      draft.targetTermId = id;
      break;
    }
    case SET_VIDEO_MODAL_DATA: {
      const { data } = payload;
      draft.videoModalData = data;
      break;
    }
    case SET_VIDEO_REMAINING_DURATION: {
      const { value } = payload;
      draft.videoRemainingDuration = value;
      break;
    }
    case UPDATE_SELECTED_CATEGORY: {
      const { id } = payload;
      draft.faqSelectedCategory = id;
      draft.faqSelectedQuestion = initialState.faqSelectedQuestion;
      break;
    }
    case UPDATE_SELECTED_QUESTION: {
      const { id } = payload;
      draft.faqSelectedQuestion = id;
      break;
    }
    case UPDATE_STEP: {
      const { step } = payload;
      draft.step = step;
      break;
    }
  }
}, initialState);

export default helpReducer;
